export enum ProviderType {
    REKOGNITION = 'rekognition',
    VISUAL_SEARCH = 'visualSearch',
    GEO_SEARCH = 'geoSearch'
}

export interface IProvider {
    providerId: string;
    name: string;
    threshold?: number;
    checked: boolean;
    receivers?: string[];
    disabledAgencies: string[];
    withoutReceivers?: boolean;
    type: ProviderType;
}

export const initialProvider: IProvider = {
    providerId: '',
    name: '',
    threshold: 80,
    checked: true,
    receivers: [""],
    disabledAgencies: [],
    type: ProviderType.REKOGNITION
}

export interface IProviderTotalStats {
    invalid: number;
    faces: number;
    valid: number;
}

export interface IProviderStatistics extends IProviderTotalStats {
    date: string;
}

export interface IProviderStats {
    date: string;
    invalid: number;
    valid: number;
}

export interface IFacesStats {
    date: string;
    faces: number;
}

export interface IProvidersStatsResult {
    images: IProviderStatistics[];
    total: IProviderTotalStats;
}

export interface IProviderStatisticsResponse {
    webIQStats: IProvidersStatsResult;
    ICMECStats: IProvidersStatsResult;
}

export const providerInitialStats: IProvidersStatsResult = {
    images: [],
    total: {
        faces: 0,
        invalid: 0,
        valid: 0
    }
}